/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function AlertIcon(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'AlertIcon',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 11 * scale,
      viewBox: '0 0 14 11',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('path', {"d":"M0 0h14v11H0z"}),createElement('path', {"d":"m13.195 9.734-5.39-8.468c-.443-.696-1.168-.696-1.61 0L.805 9.734C.362 10.43.675 11 1.5 11h11c.825 0 1.138-.57.695-1.266M7 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2m.502-3H6.498L6 3h2z","fill":"currentColor"})))
}
